import { r, c as l, a as c, h as i, H as d, g as h, o as p } from "./main-bb89b2f2.js";
import "vue";
const b = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}:host{display:inline-block}.icon-globe:hover patternlib-icon{color:var(--color-steel-600)}.icon-globe:hover patternlib-navigation-icon-item patternlib-link{color:var(--color-steel-600)!important}.static{position:static}.box-border{box-sizing:border-box}.flex{display:flex}.grid{display:grid}.h-\\[80px\\]{height:80px}.w-full{width:100%}.cursor-pointer{cursor:pointer}.flex-row{flex-direction:row}.items-center{align-items:center}.justify-center{justify-content:center}.gap-\\[4px\\]{gap:4px}.py-0{padding-bottom:var(--spacing-0);padding-top:var(--spacing-0)}.px-0{padding-left:var(--spacing-0);padding-right:var(--spacing-0)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}@media (min-width:1280px){.desktop\\:py-4{padding-bottom:var(--spacing-4);padding-top:var(--spacing-4)}}.mr-\\[10px\\]{margin-right:10px}.ml-\\[8px\\]{margin-left:8px}.h-\\[24px\\]{height:24px}.items-baseline{align-items:baseline}.justify-between{justify-content:space-between}.overflow-hidden{overflow:hidden}.text-\\[16px\\]{font-size:16px}@media (min-width:1280px){.desktop\\:min-h-\\[auto\\]{min-height:auto}}", g = b, u = class {
  /**
   * Monitoring the options data
   */
  arrayDataWatcher(e) {
    typeof e == "string" ? this._optionData = JSON.parse(e) : this._optionData = e, this.languages = this._optionData, this.stringDataWatcher(this.selected);
  }
  /**
   * Monitoring the selected data
   */
  stringDataWatcher(e) {
    if (typeof e == "string" && e != "" && this._optionData !== null && this._optionData.length > 0) {
      const a = this._optionData.filter((t) => t.value === e);
      this.selectedLanguage = a[0];
    }
  }
  constructor(e) {
    r(this, e), this.select = l(this, "lhSelect", 7), this._optionData = null, this.options = void 0, this.selected = void 0, this.width = "279px", this.show = !1, this.placement = void 0, this.headerFirstRow = !1, this.isOpen = this.show, this.mobile = !1, this.languages = [], this.selectedLanguage = null, this.selectItemClick = this.selectItemClick.bind(this), this.openFlyoutmenu = this.openFlyoutmenu.bind(this), this.onFlyoutClosed = this.onFlyoutClosed.bind(this);
  }
  componentWillLoad() {
    this.arrayDataWatcher(this.options), this.stringDataWatcher(this.selected), c() === "isMobile" && (this.mobile = !0);
  }
  connectedCallback() {
    const e = document.documentElement, a = "breakpoint", t = {
      attributes: !0
    }, s = (o) => {
      const n = p(a, o);
      n !== null && (this.mobile = n === "isMobile");
    };
    this.observer = new MutationObserver(s), this.observer.observe(e, t);
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  /**
   * Provide a method to monitor if the component gets clicked outside
   */
  handleWindowClick(e) {
    this.isOpen && e.target != this.hostElement && (this.isOpen = !1);
  }
  async openFlyoutmenu(e) {
    this.isOpen = !this.isOpen, e.stopPropagation(), e.preventDefault();
  }
  selectItemClick(e) {
    return (a) => {
      this.stringDataWatcher(e.value), this.select.emit({ selected: e.value }), this.isOpen = !1;
    };
  }
  onFlyoutClosed() {
    this.isOpen = !1;
  }
  onFlyoutOpen() {
    this.isOpen = !0;
  }
  render() {
    var e, a;
    return i(d, { key: "a87741cf5eeb4fcdddb03fdc14d04a6905950e19" }, i("patternlib-menu-flyout", { key: "b04e50fd774f2453ad5f08b934aa2866336b1b2f", headerFirstRow: this.headerFirstRow, onLhFlyoutClosed: this.onFlyoutClosed, onLhFlyoutOpen: this.onFlyoutOpen, width: this.width, show: this.isOpen, placement: this.placement, "default-align": "auto" }, i("div", { key: "ec0df24fe81a4e491ce738ec8b1b9d7e3869e00c", onClick: this.openFlyoutmenu, slot: "flyout-button", class: "icon-globe" }, i("patternlib-navigation-icon-item", { key: "6b839973ce79e3ddfa8c3be8b3b2f803a150cf3d" }, i("div", { key: "8e3125b2e3aa7565a4bdbd679e8048435c08ed68", class: "flex flex-row gap-[4px] items-center justify-center cursor-pointer h-[80px]" }, i("patternlib-link", { key: "aceb42d28c15bbd52f20813d38715151f43c3db4", tabIndex: -1, style: { flexShrink: "0" }, label: (e = this.selectedLanguage) === null || e === void 0 ? void 0 : e.value.toUpperCase(), type: "prominent", hideIcon: !0 }), i("patternlib-icon", { key: "edf7784cb0a23dfac06528eb7a2c8f37158a2578", iconName: "globe-reduced", size: "40px", slot: "icon" })))), i("div", { key: "672c8a6dd1ac45d9dfaa0cd150a6c0c60912a52d", slot: "flyout-content", class: "grid py-0 desktop:py-4 px-0 w-full box-border" }, (a = this.languages) === null || a === void 0 ? void 0 : a.map((t) => i("patternlib-menu-flyout-item", { isActionItem: !0, label: t.label, detail: t.detail, useNotoFontBold: !!["zh", "ja", "ko"].includes(t.value), onClick: this.selectItemClick(t), selected: this.selected === t.value })))));
  }
  get hostElement() {
    return h(this);
  }
  static get watchers() {
    return {
      options: ["arrayDataWatcher"],
      selected: ["stringDataWatcher"]
    };
  }
};
u.style = g;
export {
  u as patternlib_language_picker
};
